import * as z from 'zod'
import { Promocode } from '~/shared/api/promocodes'
import { OptionEnum, Option } from '~/shared/config/constants'
import {
  TransmissionEnum,
  FuelTypeEnum,
  CategoryAutoEnum,
} from '~/shared/config/enums'

export const formSchema = Promocode.schema
  .pick({
    code: true,
    title: true,
    description: true,
    usagesLeft: true,
    boundToUser: true,
    multiUse: true,
    details: true,
    expiredAt: true,
    isPromotion: true,
    isActive: true,
    beginningAt: true,
    usageLimitPerUser: true,
    driverPhones: true,
    isFirstContract: true,
    carYearsOfManufacture: true,
    carTypesTransmission: true,
    carTypesFuel: true,
    carCategories: true,
    carVinList: true,
    regionsIds: true,
    carBrandsIds: true,
    carModelsIds: true,
    carRegionsIds: true,
  })
  .superRefine((data, ctx) => {
    if (!data.isPromotion) {
      if (!data.code || data.code.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Промокод обязателен для заполнения, если это не акция',
          path: ['code'],
        })
      }
    }
  })

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<
  SchemaType,
  | 'carTypesTransmission'
  | 'carTypesFuel'
  | 'carCategories'
  | 'regionsIds'
  | 'carBrandsIds'
  | 'carModelsIds'
  | 'code'
  | 'carRegionsIds'
> & {
  carTypesTransmission?: TransmissionEnum[] | OptionEnum<TransmissionEnum>[]
  carTypesFuel?: FuelTypeEnum[] | OptionEnum<FuelTypeEnum>[]
  carCategories?: CategoryAutoEnum[] | OptionEnum<CategoryAutoEnum>[]
  regionsIds?: UniqueId[] | Option[]
  carBrandsIds?: UniqueId[] | Option[]
  carModelsIds?: UniqueId[] | Option[]
  code?: string | null
  carRegionsIds?: UniqueId[] | Option[]
}
